/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampTripShowResponse } from '../../models/camp-trip-show-response';

export interface DeleteCampTripRemove$Params {
  id: string;
}

export function deleteCampTripRemove(http: HttpClient, rootUrl: string, params: DeleteCampTripRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<CampTripShowResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteCampTripRemove.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampTripShowResponse>;
    })
  );
}

deleteCampTripRemove.PATH = '/v1/camp-trip/{id}';
